import React from 'react';
import PropTypes from 'prop-types';

import CommonPopup from 'components/common/CommonPopup';

import './MetricItem.css';

const MetricItem = ({ data, title, label, profit, helper }) => {
  if (!data) {
    return null;
  }

  return (
    <div className="analytics-main-metrics-item__component">
      <div className="wrapper">
        <h6>
          {title}
          {helper &&
            <CommonPopup
              questionIcon
              type="info"
            >
              {helper.text}
            </CommonPopup>
          }
        </h6>
        <div className="content">
          <span>{data}</span>
          {profit &&
            <span className="profit">({profit})</span>
          }
        </div>
        {label &&
          <div className="label">{label}</div>
        }
      </div>
    </div>
  );
};

MetricItem.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  title: PropTypes.string,
  label: PropTypes.string,
  profit: PropTypes.string,
  helper: PropTypes.object,
};
MetricItem.defaultProps = {
  data: null,
  title: null,
  label: null,
  profit: null,
  helper: null,
};

export default MetricItem;
